module.exports = __webpack_public_path__ + "img/pr-4.83c52c47.png";